import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
import { BackdropProvider } from './hooks/useBackdrop';
import ModalProvider from 'mui-modal-provider';
import { ConfirmProvider } from 'material-ui-confirm';
ReactDOM.render(
  <React.StrictMode>
    <Router>
      <ConfirmProvider>
        <ModalProvider>
          <BackdropProvider>
            <App />
          </BackdropProvider>
        </ModalProvider>
      </ConfirmProvider>
    </Router>

  </React.StrictMode>,
  document.getElementById("root")
);

